module.exports = __webpack_public_path__ + "img/uesr.7acfed55.svg";